import React from "react";
import { connect } from "react-redux";
import { getData, postData, showToast } from "Source/globalFunction";
import _ from "lodash";

import Select from "Components/common/Select/Select";
import Avatar from "Components/common/Avatar/Avatar";

@connect(store => {
    return {
        loggedUser: store.loggedUser,
        project: store.project,
    }
})

class ExistingUsers extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            users: [],
            searchIsLoading: false,
            isCleared: false
        }
    }

    render() {
        const { loggedUser, project } = this.props;

        const handleClear = () => {
            this.props.onSetState({
                existingUserSelected: false,
                data: {
                    id: null,
                    emailAddress: "",
                    firstName: "",
                    lastName: "",
                    phoneNumber: "",
                    username: "",
                    position: "",
                    userRole: {value: 5, label: "External Manager"}
                }
            });
        }

        const handleSelect = selected => {
            this.props.onSetState({
                existingUserSelected: true,
                data: {
                    id: selected.id,
                    emailAddress: selected.emailAddress,
                    firstName: selected.firstName,
                    lastName: selected.lastName,
                    phoneNumber: selected.phoneNumber,
                    username: selected.username,
                    position: selected.position,
                    userRole: selected.user_role.map(r => ({value: r.id, label: r.role.roleType + " " + r.role.role})).pop(),
                    supervisors: (selected.supervisors || []).length > 0 ? selected.supervisors.map(s => `${s.firstName} ${s.lastName}`).join(", ") : null
                }
            });
        }

        const searchUsers = () => {
            const url = "api/user";
            const params = {
                userId: loggedUser.data.id,
                userRole: loggedUser.data.userRole,
                userType: this.props.type,
                projectId: project.Selected.id
            }

            this.setState({...this.state, searchIsLoading: true});

            getData(url, {params}, response => {
                if(response) {
                    this.setState({
                        ...this.state, 
                        searchIsLoading: false,
                        users: response.data.result.filter(u => this.props.existingMembers.map(m => m.id).indexOf(u.id) === -1).map(u => ({
                            value: u.id, 
                            label: `${u.firstName} ${u.lastName}`,
                            id: u.id,
                            type: u.userType,
                            avatar: u.avatar,
                            firstName: u.firstName,
                            lastName: u.lastName,
                            emailAddress: u.emailAddress,
                            phoneNumber: u.phoneNumber,
                            username: u.username,
                            position: u.position,
                            user_role: u.user_role,
                            supervisors: u.supervisors
                        })
                    )}, () => {
                        this.props.onClose(false);
                    })
                }
            })
        };

        const handleRenderOption = value => {
            return (
                <div class="userOption">
                    <Avatar id={`existingUser_${value.value}`} disableInitials={true} disableTooltip={true} name={`${value.label}`} image={value.avatar !== "default.png" ? `/api/file/profile_pictures/${value.avatar}` : null} />
                    <span>{value.label}</span>
                </div>
            )
        }

        return (
            <Select 
                isSearchable={true}
                classes={{options: `addUsersOption`}}
                placeholder="Select Existing User"
                options={this.state.users}
                renderSelected={handleRenderOption}
                renderOption={handleRenderOption}
                onChange={handleSelect}
                onClearSelected={handleClear}
                isLoading={this.state.searchIsLoading}
                onOpen={searchUsers}
                isClose={this.props.isClose}
                count={10}
            />
        );
    }
}

export default ExistingUsers;